<template>
  <div class="com-create">
    <ul class="create-list">
      <router-link to="/create/works" tag="LI" >发布作品</router-link>
      <router-link to="/create/column" tag="LI" >发布专栏</router-link>
      <router-link to="/create/ques" tag="LI" >发布问答</router-link>
      <router-link to="/create/source" tag="LI" >发布素材</router-link>
    </ul>
    <router-view />
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {},
  components: {},
  data () {
    return {

    }
  },
  computed: {},
  mounted () {},
  methods: {}
}
</script>

<style scoped lang="less">
.com-create{
  padding-top: @NAVHEIGHT;
  .create-list{
    position: relative;
    font-size: 0;
    text-align: center;
    &:after{
      position: absolute;
      left: 0;
      bottom: 0;
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: #999;
    }
    li{
      display: inline-block;
      padding: 10px 0;
      margin: 0 10px;
      width: 100px;
      color: #666;
      font-size: 14px;
      line-height: 24px;
      cursor: pointer;
      transition: all .3s;
      &.router-link-active,
      &:hover{
        font-weight: bold;
        color: #333;
        font-size: 16px;
      }
    }
  }
}
@media screen and (max-width: 750px){
  .com-create{
    .create-list{
      li{
        margin: 0;
        width: 25%;
        box-sizing: border-box;
      }
    }
  }
}
</style>
